module.exports = __webpack_public_path__ + "montserrat-thin-webfont.ba231dd91951eaf08128.woff2";


//////////////////
// WEBPACK FOOTER
// D:/Honda/Trunk/WizdomWebApp/Wizdom-Web-App/src/assets/fonts/montserrat-thin-webfont.woff2
// module id = ../../../../../src/assets/fonts/montserrat-thin-webfont.woff2
// module chunks = styles